import { setPage } from './pagination';
import { get } from '../services/ajax/promise';
import { getSearchParameter } from '../services/get-search-parameter';
import { updateLoadMoreButton } from './load-more';

export const CATEGORY_QUERY_PARAM = `category_id`;
export const ACTIVE_LINK_CLASS = `category-filters__link--active`;
export const FILTERS_CONTAINER = `.js-category-filters`;
export const ALL_ARTICLES = `All`;

export const setCategory = (categoryId) => {
  const url = new URL(window.location.href);

  categoryId
    ? url.searchParams.set(CATEGORY_QUERY_PARAM, categoryId)
    : url.searchParams.delete(CATEGORY_QUERY_PARAM);

  history.replaceState(null, ``, url.href);
};

export const setActiveButton = ($categoryFiltersContainer) => {
  const queryFilterId = getSearchParameter(CATEGORY_QUERY_PARAM);

  const $activeButton = $categoryFiltersContainer.querySelector(`.${ACTIVE_LINK_CLASS}`);
  const $newActiveButton = $categoryFiltersContainer.querySelector(
    `[data-category-id="${queryFilterId ?? ALL_ARTICLES}"]`,
  );

  $activeButton?.classList.remove(ACTIVE_LINK_CLASS);
  $newActiveButton?.classList.add(ACTIVE_LINK_CLASS);
};

export const categoryFilter = ($articlesContainer, $filterButtons, setQuery, onLoad) => {
  const $categoryFiltersContainer = document.querySelector(FILTERS_CONTAINER);

  if ($articlesContainer) {
    [...$filterButtons].forEach(($button) =>
      $button.addEventListener(`click`, (event) => {
        event.preventDefault();
        const buttonFilterId =
          $button.dataset.categoryId !== ALL_ARTICLES ? $button.dataset.categoryId : null;

        const query = setQuery(buttonFilterId);

        get(query)
          .then(JSON.parse)
          .then((data) => {
            if (data.response) {
              $articlesContainer.innerHTML = data.response;
              onLoad && onLoad();

              setCategory(buttonFilterId);
              setPage(null, data.hasMoreItems);
              setActiveButton($categoryFiltersContainer);
              updateLoadMoreButton(data.hasMoreItems);
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }),
    );
  }
};
